/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export type GetAdminOpenRouterKeyUsageSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

/**
 * Key type to inspect.
 */
export const KeyType = {
  Chat: "chat",
  Internal: "internal",
} as const;
/**
 * Key type to inspect.
 */
export type KeyType = ClosedEnum<typeof KeyType>;

export type GetAdminOpenRouterKeyUsageRequest = {
  /**
   * Organization that owns the key.
   */
  organizationId: string;
  /**
   * Key type to inspect.
   */
  keyType: KeyType;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetAdminOpenRouterKeyUsageSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetAdminOpenRouterKeyUsageSecurity$outboundSchema: z.ZodMiniType<
  GetAdminOpenRouterKeyUsageSecurity$Outbound,
  GetAdminOpenRouterKeyUsageSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getAdminOpenRouterKeyUsageSecurityToJSON(
  getAdminOpenRouterKeyUsageSecurity: GetAdminOpenRouterKeyUsageSecurity,
): string {
  return JSON.stringify(
    GetAdminOpenRouterKeyUsageSecurity$outboundSchema.parse(
      getAdminOpenRouterKeyUsageSecurity,
    ),
  );
}

/** @internal */
export const KeyType$outboundSchema: z.ZodMiniEnum<typeof KeyType> = z.enum(
  KeyType,
);

/** @internal */
export type GetAdminOpenRouterKeyUsageRequest$Outbound = {
  organization_id: string;
  key_type: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetAdminOpenRouterKeyUsageRequest$outboundSchema: z.ZodMiniType<
  GetAdminOpenRouterKeyUsageRequest$Outbound,
  GetAdminOpenRouterKeyUsageRequest
> = z.pipe(
  z.object({
    organizationId: z.string(),
    keyType: KeyType$outboundSchema,
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      organizationId: "organization_id",
      keyType: "key_type",
      gramSession: "Gram-Session",
    });
  }),
);

export function getAdminOpenRouterKeyUsageRequestToJSON(
  getAdminOpenRouterKeyUsageRequest: GetAdminOpenRouterKeyUsageRequest,
): string {
  return JSON.stringify(
    GetAdminOpenRouterKeyUsageRequest$outboundSchema.parse(
      getAdminOpenRouterKeyUsageRequest,
    ),
  );
}
